import { render, staticRenderFns } from "./Emitters.vue?vue&type=template&id=ab29b8e4&"
import script from "./Emitters.vue?vue&type=script&lang=js&"
export * from "./Emitters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Users/lucianocolucci/Desktop/Share Windows/IngeniAR/WebProject/Syscore-mods/Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports